import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { SeoHead } from "../components/seo/SeoHead";
import { parseTrialHandoffHash, saveTrialSession } from "../utils/trial-session";

/** Réception handoff Suite → parcours trial (compte existant). */
export function TrialHandoffPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const session = parseTrialHandoffHash(window.location.hash);
    if (!session) {
      setError("Lien expiré ou invalide. Reconnectez-vous depuis la Suite ITaaS.");
      return;
    }
    saveTrialSession(session);
    const qs = new URLSearchParams(params);
    qs.set("step", "3");
    qs.set("existing", "1");
    qs.set("from", "engine");
    navigate(`/trial?${qs.toString()}`, { replace: true });
  }, [navigate, params]);

  if (error) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
        <SeoHead
          title="Handoff essai"
          description="Liaison de session essai ITaaS."
          canonicalPath="/trial/handoff"
          noIndex
        />
        <div className="alert alert-warning" style={{ maxWidth: 480 }}>
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center">
      <SeoHead
        title="Handoff essai"
        description="Liaison de session essai ITaaS."
        canonicalPath="/trial/handoff"
        noIndex
      />
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" />
        <p className="text-secondary mb-0">Connexion à votre parcours essai…</p>
      </div>
    </div>
  );
}
